export default "__VITE_ASSET__BCc2OSY7__"